var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"component"},'component',{
    ..._vm.$attrs,
    disabled: _vm.disabled,
    type: _vm.type,
    class: _vm.classNames,
  },false),[_vm._t("default",function(){return [(_vm.labelComp || _vm.$scopedSlots.label)?_c('span',{staticClass:"elder-button__label"},[_vm._t("label",function(){return [_vm._v("\n        "+_vm._s(_vm.labelComp)+"\n      ")]})],2):_vm._e(),(_vm.iconComp || _vm.$scopedSlots.icon)?_c('span',{staticClass:"elder-button__icon"},[_vm._t("icon",function(){return [_c('Icon',_vm._b({},'Icon',_vm.iconComp,false))]},{"icon":_vm.iconComp,"state":_vm.state})],2):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }